module.exports = __webpack_public_path__ + "25670b4ac8dafec3250bb4f571e43def.ttf";